import { global } from "../../constants";

export const data = {
  banner: {
    base: "服务",
    background: global.banner + "sts_services.webp",
    title: "STS船对船操作",
    crumb: "STS船对船操作",
  },
  icon: "fa-solid fa-exchange-alt",
  shortDescription:
    "STS船对船操作的综合服务：规划、许可、技术监督与风险管理，确保转运安全合规。",
  title: "STS船对船操作",
  features: {
    title: "STS船对船操作",
    deliverables: "交付物",
    reqDocuments: "所需文件",
    subtitle:
      "STS船对船（船间转运）操作的规划、执行与技术监督，符合MARPOL、OCIMF/ISGOTT指南及当地法规。",
    description: `我们为STS操作提供全方位服务，包括船舶预评估、STS计划制定与验证、专业团队（STS Master/Loading Master）协调、设备与转运系统核查、许可管理及与港口和船旗当局的沟通，并在事故与索赔管理方面提供支持。我们的方法结合了合规、OCIMF/ISGOTT最佳实践及合规管控，以降低运营、环境和法律风险。`,
    viewDetail: "查看详情",
    feats: [
      {
        key: "plan_sts",
        title: "STS操作计划制定与验证（MARPOL/OCIMF）",
        summary:
          "根据MARPOL（附录I）和OCIMF/ISGOTT指南起草STS计划，并由船旗当局/客户批准签署。",
        details:
          "我们制定STS计划，包括操作描述、操作限制、认证设备与软管、到港与离港程序、职责分工（Masters, Loading Master）、沟通及强制性转运前检查表。必要时协助船旗当局或主管部门审批。",
        deliverables: [
          "完整STS计划及签署版",
          "转运前及操作期间检查表",
          "审批与沟通记录"
        ],
        requiredDocs: [
          "先前STS计划格式或操作方模板",
          "责任人及主管部门联系方式",
          "软管与设备技术规格"
        ],
        icon: "fa-solid fa-file-lines",
        image: global.services + "operations_sts/1.webp",
      },
      {
        key: "evaluacion_previa",
        title: "预评估与操作尽职调查",
        summary:
          "在批准STS操作前，对船舶、船员、所有人及舱单进行技术与法律核查。",
        details:
          "我们进行KYC及技术尽职调查：船体与舱兼容性、船旗注册、安全证书、事故历史、处罚记录及保险商核查。包括与收货人、船东及STS设备供应商的沟通。",
        deliverables: [
          "法律与技术尽职调查报告",
          "兼容性与风险清单",
          "风险缓解建议"
        ],
        requiredDocs: [
          "船舶分类与安全证书",
          "船舶登记与所有权文件",
          "索赔/事故历史及保险单"
        ],
        icon: "fa-solid fa-search",
        image: global.services + "operations_sts/2.webp",
      },
      {
        key: "supervision_tecnica",
        title: "技术监督与专业人员（STS Master / Loading Master）",
        summary:
          "提供与协调STS监督员（Masters/Loading Masters）及技术人员，负责操作指挥与监督。",
        details:
          "我们提供或协调认证技术人员与监督员，负责操作指挥、沟通管理、连接核查及泵送启动/停止授权。制定操作角色与统一指挥联系方式。",
        deliverables: [
          "STS Master / Loading Master分配",
          "角色与职责清单",
          "转运后操作报告"
        ],
        requiredDocs: [
          "技术人员简历与证书",
          "登船授权与许可",
          "操作计划与时间窗口"
        ],
        icon: "fa-solid fa-user-astronaut",
        image: global.services + "operations_sts/3.webp",
      },
      {
        key: "equipamiento_y_mooring",
        title: "设备、护舷与系泊操作",
        summary:
          "核查与提供系泊系统、护舷及认证安全设备/软管，保障转运安全。",
        details:
          "我们核查护舷规格、系泊长度、缆绳张力、绞盘能力、船体保护及软管与货物兼容性。协调护舷供应商与泵送系统，并在操作前进行完整性测试。",
        deliverables: [
          "设备与护舷检查清单",
          "软管与连接兼容性报告",
          "计算张力的系泊计划"
        ],
        requiredDocs: [
          "软管与护舷技术规格",
          "货物数据（密度、温度）",
          "设备维护记录"
        ],
        icon: "fa-solid fa-anchor",
        image: global.services + "operations_sts/4.webp",
      },
      {
        key: "seguridad_medida_contaminacion",
        title: "HSE、溢油应急与环境突发事件",
        summary:
          "STS操作期间的HSE规划、防范措施与溢油应急预案（OSCP）协调。",
        details:
          "我们制定专属HSE管控：气体监测、点火源管控、应急沟通、空间隔离方案，并在溢油时与OSCP/主管部门协调。包括应急围油设备与浮筒的可用性（如适用）。",
        deliverables: [
          "针对操作的HSE与应急预案",
          "围油设备与应急联系人清单",
          "操作后安全观察报告"
        ],
        requiredDocs: [
          "现行应急/OSCP预案",
          "气体仪表与校准证书",
          "船舶安全操作规程"
        ],
        icon: "fa-solid fa-shield-halved",
        image: global.services + "operations_sts/5.webp",
      },
      {
        key: "compliance_y_permisos",
        title: "许可、通知与当地合规（含委内瑞拉水域要求）",
        summary:
          "港口许可管理、主管部门通知及当地合规（如委内瑞拉INEA要求）。",
        details:
          "我们办理港口与海事主管部门授权，提交法规通知（如水域主管部门），协调通道与授权区域，并核查当地监管要求的保险与担保。",
        deliverables: [
          "许可/通知办理与获取",
          "与主管部门沟通记录",
          "已满足的当地要求清单"
        ],
        requiredDocs: [
          "提交主管部门的操作申请/计划",
          "船舶文件与货物舱单",
          "所需保险单与担保"
        ],
        icon: "fa-solid fa-landmark",
        image: global.services + "operations_sts/6.webp",
      },
      {
        key: "documentacion_entrega",
        title: "文件、认证与行政结案",
        summary:
          "生成转运证书、货物交付单及时间/体积记录，满足法律与商业需求。",
        details:
          "我们出具转运记录（数量转运声明）、体积与温度控制、货物收/发证书及用于结算与索赔的会计文件。保留操作档案以备后续审计。",
        deliverables: [
          "转运记录与声明（QTY statement）",
          "体积与转运参数报告",
          "操作档案与签名记录"
        ],
        requiredDocs: [
          "舱单与提单/货物文件",
          "测量记录与实验室证书（如适用）",
          "双方授权签名"
        ],
        icon: "fa-solid fa-file-contract",
        image: global.services + "operations_sts/7.webp",
      },
      {
        key: "seguros_y_reclamaciones",
        title: "保险、民事责任与索赔管理",
        summary:
          "STS专属保险配置咨询及转运后事故/索赔管理。",
        details:
          "我们审核H&M、P&I及货物保险，识别STS期间保障缺口，建议扩展或临时批单，并在损失、溢油或第三方损害时协调理赔。",
        deliverables: [
          "保障分析与缺口报告",
          "批单或临时保单建议",
          "理赔协助与保险公司协调"
        ],
        requiredDocs: [
          "现行保单（H&M、P&I、货物）",
          "事故与鉴定报告",
          "双方正式沟通"
        ],
        icon: "fa-solid fa-hand-holding-dollar",
        image: global.services + "operations_sts/8.webp",
      }
    ],
  },
  ctaText: "申请STS操作或报价",
  ctaLink: "/contact?service=sts-operations",
};
